import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

const routeRecord: RouteRecordRaw = {
  name: 'client.notifications',
  path: 'notifications',
  component: () => import('src/client/pages/ClientNotifications.vue'),
  meta: {
    roles: [Roles.Client],
    supportedPlatforms: ['desktop', 'mobile', 'native'],
    excludeEnv: [],
  },
}

export default routeRecord
